import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    OutlinedInput,
    Stack,
    Typography,
    useMediaQuery,
    TextField
} from '@mui/material';

// project imports
import AuthWrapper1 from 'views/pages/AuthWrapper1';
import AuthCardWrapper from 'views/pages/AuthCardWrapper';
import Logo from 'ui-component/Logo';
import AuthFooter from 'ui-component/cards/AuthFooter';
import { useIntl } from 'react-intl';
import { ChangeEvent, useEffect, useState } from 'react';
import AnimateButton from 'ui-component/extended/AnimateButton';
// redux
import { dispatch, useSelector } from 'store';
import { getRoles } from 'store/slices/catalog';
import AutocompleteVirtualized from 'ui-component/selects/AutocompleteVirtualized';
import { registerSuppliersProps } from 'types/slices/slices';
import { AprovalSupplierType, ProfileSupplierType } from 'types/catalog';
import axiosServices from 'utils/axios';
// assets

// ================================|| AUTH3 - LOGIN ||================================ //

const AuthLoginSuppliers = () => {
    const [suppliers, setSuppliers] = useState<registerSuppliersProps>({
        name: '',
        lastName: '',
        businessName: '',
        email: '',
        profileId: 0,
        accessProfileId: 0
    });

    const [valuesApproval, setValuesApproval] = useState<AprovalSupplierType>({
        Perfil: '',
        IdPerfil: 0
    });
    const [inputApprovalValue, setInputApprovalValue] = useState<string>('');
    const [valuesProfile, setValuesProfile] = useState<ProfileSupplierType>({ NOMBRE: '', ID: 0 });
    const [inputProfileValue, setInputProfileValue] = useState<string>('');
    const [localLoading, setLocalLoading] = useState(false);
    const { roles, loading } = useSelector((state) => state.catalogue);

    const theme = useTheme();
    const intl = useIntl();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setSuppliers((prevValues) => ({
            ...prevValues,
            [name]: value
        }));
    };
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        dispatch(getRoles());
    }, []);
    useEffect(() => {
        setSuppliers((prev) => ({
            ...prev,
            profileId: Number(valuesProfile?.ID),
            accessProfileId: Number(valuesApproval?.IdPerfil)
        }));
    }, [valuesProfile, valuesApproval]);
    const formik = useFormik({
        initialValues: {
            name: suppliers.name,
            lastName: suppliers.lastName,
            businessName: suppliers.businessName,
            email: suppliers.email,
            submit: null,
            valueApproval: valuesApproval?.IdPerfil,
            valueProfile: valuesProfile?.ID
        },
        validationSchema: Yup.object({
            name: Yup.string().required(
                intl.formatMessage({
                    id: 'name_required'
                })
            ),
            lastName: Yup.string().required(
                intl.formatMessage({
                    id: 'lastName_required'
                })
            ),
            businessName: Yup.string().required(
                intl.formatMessage({
                    id: 'business_name_required'
                })
            ),
            email: Yup.string()
                .email(
                    intl.formatMessage({
                        id: 'email_format'
                    })
                )
                .required(
                    intl.formatMessage({
                        id: 'email_required'
                    })
                ),
            valueApproval: Yup.string().required(
                intl.formatMessage({
                    id: 'approval_required'
                })
            ),
            valueProfile: Yup.string().required(
                intl.formatMessage({
                    id: 'profile_required'
                })
            )
        }),
        onSubmit: async (values, { setSubmitting }) => {
            // REGISTERSUPPLIERS
            setLocalLoading(true);
            await axiosServices.post(`/loolu/api/catalog/pub/vendors/access/request`, suppliers);
            setLocalLoading(false);
            setSubmitting(false);
        }
    });
    useEffect(() => {
        formik.setValues((prevValues) => ({
            ...prevValues,
            name: suppliers.name,
            lastName: suppliers.lastName,
            businessName: suppliers.businessName,
            email: suppliers.email,
            valueApproval: valuesApproval?.IdPerfil,
            valueProfile: valuesProfile?.ID
        }));
    }, [suppliers, inputProfileValue, inputApprovalValue, formik, valuesApproval?.IdPerfil, valuesProfile?.ID]);
    return (
        <AuthWrapper1>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item xs={12}>
                                        <Grid
                                            component="form"
                                            onSubmit={formik.handleSubmit}
                                            container
                                            item
                                            spacing={2}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item sx={{ mb: 3, mt: 2 }}>
                                                <Link to="#">
                                                    <Logo />
                                                </Link>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid
                                                    container
                                                    item
                                                    direction={matchDownSM ? 'column-reverse' : 'row'}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >
                                                    <Grid item>
                                                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                            <Typography
                                                                color={theme.palette.secondary.main}
                                                                gutterBottom
                                                                variant={matchDownSM ? 'h3' : 'h2'}
                                                            >
                                                                {intl.formatMessage({
                                                                    id: 'hi_welcome'
                                                                })}
                                                            </Typography>
                                                            <Typography
                                                                variant="caption"
                                                                fontSize="16px"
                                                                textAlign={matchDownSM ? 'center' : 'inherit'}
                                                            >
                                                                {intl.formatMessage({
                                                                    id: 'enter_credentials'
                                                                })}
                                                            </Typography>
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth sx={{ ...theme.typography.customInput }}>
                                                    <InputLabel htmlFor="outlined-adornment-user">
                                                        {intl.formatMessage({
                                                            id: 'name'
                                                        })}{' '}
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        fullWidth
                                                        id="outlined-adornment-user"
                                                        type="text"
                                                        name="name"
                                                        onChange={handleChange}
                                                    />
                                                    {formik.touched.name && formik.errors.name && (
                                                        <FormHelperText error id="outlined-adornment-user">
                                                            {formik.errors.name}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth sx={{ ...theme.typography.customInput }}>
                                                    <InputLabel htmlFor="outlined-adornment-lastName">
                                                        {intl.formatMessage({
                                                            id: 'last_name'
                                                        })}{' '}
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        fullWidth
                                                        id="outlined-adornment-lastName"
                                                        type="text"
                                                        name="lastName"
                                                        onChange={handleChange}
                                                    />
                                                    {formik.touched.lastName && formik.errors.lastName && (
                                                        <FormHelperText error id="outlined-adornment-user">
                                                            {formik.errors.lastName}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth sx={{ ...theme.typography.customInput }}>
                                                    <InputLabel htmlFor="outlined-adornment-business-name">
                                                        {' '}
                                                        {intl.formatMessage({
                                                            id: 'business_name'
                                                        })}{' '}
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        fullWidth
                                                        id="outlined-adornment-business-name"
                                                        type="text"
                                                        name="businessName"
                                                        onChange={handleChange}
                                                    />
                                                    {formik.touched.businessName && formik.errors.businessName && (
                                                        <FormHelperText error id="outlined-adornment-business-name">
                                                            {formik.errors.businessName}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth sx={{ ...theme.typography.customInput }}>
                                                    <InputLabel htmlFor="outlined-adornment-email">
                                                        {intl.formatMessage({
                                                            id: 'email'
                                                        })}
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        fullWidth
                                                        id="outlined-adornment-email"
                                                        type="text"
                                                        name="email"
                                                        onChange={handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.email}
                                                    />
                                                    {formik.touched.email && formik.errors.email && (
                                                        <FormHelperText error id="outlined-adornment-email">
                                                            {formik.errors.email}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sx={{ mt: 2 }}>
                                                <AutocompleteVirtualized
                                                    fullWidth
                                                    loading={loading || localLoading}
                                                    noOptionsText={intl.formatMessage({
                                                        id: 'no_options'
                                                    })}
                                                    value={valuesApproval}
                                                    onChange={(event: any, newValue: AprovalSupplierType | null) => {
                                                        newValue && setValuesApproval(newValue);
                                                    }}
                                                    inputValue={inputApprovalValue}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputApprovalValue(newInputValue);
                                                    }}
                                                    getOptionLabel={(option) => option.Perfil}
                                                    id="autocomplete-mui-aproval"
                                                    options={roles?.approval || []}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={intl.formatMessage({
                                                                id: 'approval'
                                                            })}
                                                        />
                                                    )}
                                                    renderOption={(props, option, { selected }) => (
                                                        <Typography
                                                            {...props}
                                                            key={`${option}`}
                                                            sx={{
                                                                p: 1,

                                                                transition: 'all 350ms ease',
                                                                '&:hover': {
                                                                    background: theme.palette.divider,
                                                                    transition: 'all 350ms ease'
                                                                }
                                                            }}
                                                        >
                                                            {option.Perfil}
                                                        </Typography>
                                                    )}
                                                />
                                                {formik.touched.valueApproval && formik.errors.valueApproval && (
                                                    <FormHelperText error id="autocomplete-mui-profile">
                                                        {formik.errors.valueApproval}
                                                    </FormHelperText>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sx={{ mt: 2 }}>
                                                <AutocompleteVirtualized
                                                    fullWidth
                                                    loading={loading || localLoading}
                                                    noOptionsText={intl.formatMessage({
                                                        id: 'no_options'
                                                    })}
                                                    value={valuesProfile}
                                                    onChange={(event: any, newValue: ProfileSupplierType | null) => {
                                                        newValue && setValuesProfile(newValue);
                                                    }}
                                                    inputValue={inputProfileValue}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputProfileValue(newInputValue);
                                                    }}
                                                    getOptionLabel={(option) => option.NOMBRE}
                                                    id="autocomplete-mui-profile"
                                                    options={roles?.profile || []}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label={intl.formatMessage({
                                                                id: 'profile'
                                                            })}
                                                        />
                                                    )}
                                                    renderOption={(props, option, { selected }) => (
                                                        <Typography
                                                            {...props}
                                                            key={`${option}`}
                                                            sx={{
                                                                p: 1,

                                                                transition: 'all 350ms ease',
                                                                '&:hover': {
                                                                    background: theme.palette.divider,
                                                                    transition: 'all 350ms ease'
                                                                }
                                                            }}
                                                        >
                                                            {option.NOMBRE}
                                                        </Typography>
                                                    )}
                                                />
                                                {formik.touched.valueProfile && formik.errors.valueProfile && (
                                                    <FormHelperText error id="autocomplete-mui-profile">
                                                        {formik.errors.valueProfile}
                                                    </FormHelperText>
                                                )}
                                            </Grid>
                                            <Grid item xs={12}>
                                                <AnimateButton>
                                                    <Button
                                                        sx={{
                                                            mt: 2,
                                                            mb: 2,
                                                            width: '100%'
                                                        }}
                                                        color="secondary"
                                                        size="large"
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Sign In
                                                    </Button>
                                                </AnimateButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                    <AuthFooter />
                </Grid>
            </Grid>
        </AuthWrapper1>
    );
};

export default AuthLoginSuppliers;
